module.exports = __webpack_public_path__ + "cu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cu.svg
// module id = 504
// module chunks = 0